module.exports = __webpack_public_path__ + "static/img/012.f41c868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/012.png
// module id = aCkd
// module chunks = 0